import { theme } from '../../../theme';
import { ThemeProvider } from '@mui/material/styles';
import OrderTable from './OrderTable';
import { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const OrderList = () => {
  const { t } = useTranslation();
  const [orderId, setOrderId] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [orderStatus, setOrderStatus] = useState('');

  const [searchParams] = useSearchParams();
  const [autoOpenOrderId, setAutoOpenOrderId] = useState<string | undefined>(searchParams.get('orderId') || undefined);
  const [initialTab, setInitialTab] = useState<string>(searchParams.get('tab') || 'new');

  useEffect(() => {
    setAutoOpenOrderId(searchParams.get('orderId') || undefined);
    setInitialTab(searchParams.get('tab') || 'all');
  }, [searchParams]);


  return (
    <ThemeProvider theme={theme}>
        <>
          <Typography
            variant="h5" fontWeight="bold" mb={2}>
            {t('orderManagement.title')}
          </Typography>
          <OrderTable
            orderId={orderId}
            setOrderId={setOrderId}
            orderStatus={orderStatus}
            setOrderStatus={setOrderStatus}
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            autoOpenOrderId={autoOpenOrderId}
            initialTab={initialTab}
          />
        </>
    </ThemeProvider>
  );
};

export default OrderList;
